const bankContext = require.context("@/static", true, /\.json$/);

const HASH_JSON = /_([a-f0-9]{22,})\.json$/i;

function shortKeyForHashKey(k) {
  if (!HASH_JSON.test(k)) return null;
  const name = k.replace(/^\.\//, "").replace(HASH_JSON, ".json");
  return "./" + name;
}

const SEMESTER_ORDER = ["上半年", "下半年"];

export function getBankList() {
  const keys = bankContext.keys();
  const set = new Set(keys);
  return keys
    .filter((k) => {
      const shortKey = shortKeyForHashKey(k);
      if (!shortKey) return true;
      return !set.has(shortKey);
    })
    .map((k) => {
      const rel = k
        .replace(/^\.\//, "")
        .replace(/\.json$/, "")
        .replace(/_([a-f0-9]{22,})$/i, "");
      const title = rel.includes("/") ? rel.split("/").pop() : rel;
      return { id: k, title, load: () => bankContext(k) };
    });
}

/** @returns {{ title: string, banks: ReturnType<getBankList> }[]} */
export function getBankSections() {
  const list = getBankList();
  /** @type {Map<string, ReturnType<getBankList>>} */
  const byFolder = new Map();
  for (const b of list) {
    const segment = b.id.replace(/^\.\//, "").split("/")[0];
    if (!byFolder.has(segment)) byFolder.set(segment, []);
    byFolder.get(segment).push(b);
  }
  const sections = [];
  for (const name of SEMESTER_ORDER) {
    const banks = byFolder.get(name);
    if (banks && banks.length) sections.push({ title: name, banks });
  }
  for (const [name, banks] of byFolder) {
    if (!SEMESTER_ORDER.includes(name) && banks.length) {
      sections.push({ title: name, banks });
    }
  }
  return sections;
}

export function findBankById(id) {
  return getBankList().find((b) => b.id === id) || null;
}

export function extractOptions(raw) {
  const letters = ["A", "B", "C", "D", "E", "F"];
  return letters
    .map((k) => {
      const text = raw["选项" + k];
      if (text == null || !String(text).trim()) return null;
      return { key: k, text: String(text).trim() };
    })
    .filter(Boolean);
}

export function normalizeAnswerLetters(ans) {
  const s = String(ans || "")
    .toUpperCase()
    .replace(/[^A-F]/g, "");
  const arr = [...s].filter((c) => "ABCDEF".includes(c));
  return [...new Set(arr)].sort().join("");
}

export function answersMatch(user, correct) {
  return normalizeAnswerLetters(user) === normalizeAnswerLetters(correct);
}
